import type { RejectionReason } from '../types/products.types';

export function parseRejectionReasons(rawMeta: unknown): RejectionReason[] {
    if (rawMeta === null || typeof rawMeta !== 'object') return [];
    const reasons = (rawMeta as { rejection_reasons?: unknown }).rejection_reasons;
    if (!Array.isArray(reasons)) return [];

    return reasons.filter(isRejectionReason);
}

function isRejectionReason(value: unknown): value is RejectionReason {
    if (value === null || typeof value !== 'object') return false;
    const r = value as Record<string, unknown>;
    return typeof r.rule === 'string' && (r.result === 'pass' || r.result === 'fail');
}
